import DoubleRoulette from '@/components/Roulette/RouletteVideoContent/RouletteVideo/Roulette/Slider/Roulette';
import RouletteEndBanner from '@/components/core/Games/RouletteEndBanner';
import { GameReportBoardRound } from '../props';
import styles from './styles.module.scss';

export default function DoubleGameReportBoard({ round }: GameReportBoardRound) {
  return (
    <div className={styles.container}>
      <RouletteEndBanner
        isClosed={false}
        multiplier={round?.roulette?.tile?.multiplier?.toNumberString()}
      />
      <DoubleRoulette round={round} spinningTime={0.7} />
    </div>
  );
}
